import React, { useEffect, useState } from "react";
import { BackToTopButton } from '../css/_styledComponents';

export default function BackToTo () {
  const [inView, setInView] = useState('relative');
  
  useEffect(() => {
    setInView(false);
    window.addEventListener('scroll', showButton);
    return () => {
      window.removeEventListener('scroll', showButton);
    };
  }, []);

  const showButton = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      windowHeight > 500 ? setInView(true) : setInView(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  return (
    <BackToTopButton
      inView={inView}
      onClick={scrollToTop}
    >
      Back to Top ↑
    </BackToTopButton>
  );
};
